<template>
  <div
    ref="dropdownMenu"
    :class="[
      'dropdown-menu m-0',
      {
        'dropdown-menu--medium': width === 'md',
        'dropdown-menu--large': width === 'lg',
        'dropdown-menu--max-content': width === 'max-content',
        'w-100': width === 'inherit',
        'dropdown-menu--fixed-height': heightLimit === 'fixed'
      }
    ]"
    @scroll.passive="checkScroll"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'DropdownMenu',
  props: {
    width: {
      type: String,
      default: '',
    },
    heightLimit: {
      type: String,
      default: 'fixed',
    },
  },
};
</script>
